<template>
    <v-dialog v-model="dialog" width="1300" :fullscreen="isMobileOrTablet()" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col v-if="action == 'edit'" cols="12" class="mb-3">
                            <v-btn class="mr-1" v-if="status == true" :loading="loading" text="Deactivate" variant="elevated" elevation="1" color="red" @click="confirmDeactivate = true"></v-btn>
                            <v-btn class="mr-1" v-if="status == false" :loading="loading" text="Reactivate" variant="elevated" elevation="1" color="green" @click="confirmReactivate = true"></v-btn>
                            <v-btn class="mr-1" :loading="loading" text="Reset Password" variant="elevated" elevation="1" color="orange-darken-1" @click="confirmReset = true"></v-btn>
                        </v-col>
                        <v-col cols="12">
                            <v-card title="Basic Information" elevation="4">
                                <v-card-text>
                                    <v-divider></v-divider>
                                    <v-row class="mt-2">
                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                v-model="fname"
                                                label="First Name"
                                                :rules="[formRules.required]"
                                                variant="outlined"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                >
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                v-model="mname"
                                                label="Middle Name"
                                                variant="outlined"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                >
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                v-model="lname"
                                                label="Last Name"
                                                :rules="[formRules.required]"
                                                variant="outlined"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                >
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-text-field
                                                v-model="suffix"
                                                label="Suffix"
                                                hint="Ex: Jr or Sr,"
                                                variant="outlined"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                >
                                                </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-text-field
                                                v-model="post_nominal"
                                                label="Post Nominal"
                                                hint="Ex: Ph.D, MIT"
                                                variant="outlined"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                >
                                                </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                v-model="undergraduate"
                                                label="Bachelor's Degree"
                                                variant="outlined"
                                                hint="Ex: Bachelor of Science in Information Technology (BSIT)"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                >
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                v-model="graduate"
                                                label="Master's Degree"
                                                variant="outlined"
                                                hint="Ex: Master of Information Technology (MIT)"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                >
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                v-model="post_graduate"
                                                label="Doctoral/Professional Degree"
                                                variant="outlined"
                                                hint="Ex: Doctor of Information Technology (MIT)"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                >
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                v-model="core_time"
                                                label="Core Time"
                                                variant="outlined"
                                                hint="Ex: MW 8:00-5:00, TTH 7:30-5:30, F 8:00-3:00"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                >
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                v-model="consultation_time"
                                                label="Consultation Time"
                                                variant="outlined"
                                                hint="Ex: MF 10:30-12:00"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                >
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                v-model="designation"
                                                label="Designation for Document Signatory"
                                                variant="outlined"
                                                hint="Ex: Dean, Institute of Computing"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                >
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12">
                            <v-card title="Academic Information" elevation="4">
                                <v-card-text>
                                    <v-divider></v-divider>
                                    <v-row class="mt-2">
                                        <v-col cols="12" md="6">
                                            <v-autocomplete
                                                v-model="employmentStatusId"
                                                label="Employment Status"
                                                variant="outlined"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                :items="employmentStatusData"
                                                item-title="description"
                                                item-value="id"
                                                clearable
                                                >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-autocomplete
                                                v-model="academicRankId"
                                                label="Academic Rank"
                                                variant="outlined"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                :items="academicRankData"
                                                item-title="description"
                                                item-value="id"
                                                clearable
                                                >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-autocomplete
                                                v-model="programId"
                                                label="Program"
                                                variant="outlined"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                :items="programData"
                                                item-title="name"
                                                item-value="id"
                                                clearable
                                                >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-autocomplete
                                                v-model="officeId"
                                                label="Office/Institute"
                                                variant="outlined"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                :items="officeData"
                                                item-title="name"
                                                item-value="id"
                                                clearable
                                                >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-autocomplete
                                                v-model="positionId"
                                                label="Position"
                                                variant="outlined"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                :items="positionData"
                                                item-title="name"
                                                item-value="id"
                                                clearable
                                                >
                                            </v-autocomplete>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12">
                            <v-card title="Security Information" elevation="4">
                                <v-card-text>
                                    <v-divider></v-divider>
                                    <v-row class="mt-2">
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                            v-model="email"
                                            label="Email"
                                            :rules="[formRules.required,formRules.email, newFormRules.dnscEmail]"
                                            variant="outlined"
                                            rounded="lg"
                                            type="email"
                                            :readonly="action == 'edit'"
                                            >
                                            </v-text-field>
                                        </v-col>
                                        <v-col v-if="action == 'add'" cols="12" md="6">
                                            <v-text-field
                                            v-model="password"
                                            label="Password"
                                            :rules="[formRules.required]"
                                            variant="outlined"
                                            rounded="lg"
                                            >
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col v-if="action == 'edit'" cols="12">
                            <v-card title="Role Management" elevation="4">
                                <v-card-text>
                                    <v-divider></v-divider>
                                    <v-row class="mt-2">
                                        <v-col cols="12" md="4">
                                            <v-select
                                            v-model="roles"
                                            clearable
                                            chips
                                            variant="outlined"
                                            :rules="[formRules.required]"
                                            label="Role"
                                            color="darkGreen"
                                            :items="roleData"
                                            item-title="name"
                                            item-value="id"
                                            rounded="lg"
                                            multiple
                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                    <v-divider></v-divider>
                                        <v-row dense class="mt-2">
                                            <v-col cols="12" md="6">
                                                <v-btn @click="showAddRoleDialog()" color="darkGreen">Add Role</v-btn>
                                            </v-col>
                                        </v-row>
                                        <v-card v-for="roles in rolesData" :key="roles" elevation="4" class="mt-3">
                                            <v-card-text>
                                                <v-row>
                                                    <v-col cols="12" md="6">
                                                        <div class="font-weight-bold">Program:</div>
                                                        <div>{{ roles.program ? roles.program.name : '---' }}</div>
                                                    </v-col>
                                                    <v-col cols="12" md="6">
                                                        <div class="font-weight-bold">Institute/Office:</div>
                                                        <div>{{ roles.office ? roles.office.name : '---' }}</div>
                                                    </v-col>
                                                    <v-col cols="12" md="3">
                                                        <div class="font-weight-bold">Role:</div>
                                                        <div>{{ roles.role ? roles.role.name : '---' }}</div>
                                                    </v-col>
                                                    <v-col cols="12" md="6">
                                                        <div class="font-weight-bold">Designation:</div>
                                                        <div>{{ roles.designation ? roles.designation : '---' }}</div>
                                                    </v-col>
                                                    <v-col cols="12" md="3" class="text-right mt-4">
                                                        <v-btn @click="showEditRoleDialog(roles)" size="small" color="routesColor" class="mr-2">Edit Role</v-btn>
                                                        <v-btn @click="showRemoveRoleDialog(roles)" size="small" color="red">Remove Role</v-btn>
                                                    </v-col>
                                                </v-row>
                                            </v-card-text>
                                        </v-card>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn class="mr-1" :loading="loading" text="Save" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <RolesDialog ref="RolesDialog" @refresh="loadRoles()" />

    <v-dialog v-model="confirmDeactivate" width="450" persistent>
        <v-card color="secondary" rounded="lg" class="pa-2">
            <v-card-text>
                <div class="font-weight-bold mt-2">Are you sure you want deactivate this account?</div>
            </v-card-text>
            <template v-slot:actions>
            <v-spacer></v-spacer>

            <v-btn @click="confirmDeactivate = false" :disabled="loading" variant="outlined">
                Cancel
            </v-btn>
            <v-btn :loading="loading" @click="deactivateAccount()" color="red" variant="elevated">
                Confirm
            </v-btn>
            </template>
        </v-card>
    </v-dialog>

    <v-dialog v-model="confirmReactivate" width="450" persistent>
        <v-card color="secondary" rounded="lg" class="pa-2">
            <v-card-text>
                <div class="font-weight-bold mt-2">Are you sure you want reactivate this account?</div>
            </v-card-text>
            <template v-slot:actions>
            <v-spacer></v-spacer>

            <v-btn @click="confirmReactivate = false" :disabled="loading" variant="outlined">
                Cancel
            </v-btn>
            <v-btn :loading="loading" @click="reactivateAccount()" color="darkGreen" variant="elevated">
                Confirm
            </v-btn>
            </template>
        </v-card>
    </v-dialog>

    <v-dialog v-model="confirmReset" width="450" persistent>
        <v-card color="secondary" rounded="lg" class="pa-2">
            <v-card-text>
                <div class="font-weight-bold mt-2">Are you sure you want reset the password for this account? <br><br> New password: <br> aumsreset1234 <br><br></div>
                 <div class="font-weight-light mt-2">Note: Once confirmed, please inform the account owner to change his/her password in profile.</div>
            </v-card-text>
            <template v-slot:actions>
            <v-spacer></v-spacer>

            <v-btn @click="confirmReset = false" :disabled="loading" variant="outlined">
                Cancel
            </v-btn>
            <v-btn :loading="loading" @click="resetPassword()" color="darkGreen" variant="elevated">
                Confirm
            </v-btn>
            </template>
        </v-card>
    </v-dialog>

    <v-dialog v-model="confirmDeleteRole" width="450" persistent>
        <v-card color="secondary" rounded="lg" class="pa-2">
            <v-card-text>
                <div class="font-weight-bold mt-2 text-h6">Are you sure you want remove this role information?</div>
                <div class="font-weight-light mt-2">Note: Once confirmed, The action cannot be reversible.</div>
            </v-card-text>
            <template v-slot:actions>
            <v-spacer></v-spacer>

            <v-btn @click="confirmDeleteRole = false" :disabled="loading" variant="outlined">
                Cancel
            </v-btn>
            <v-btn :loading="loading" @click="removeRole()" color="red" variant="elevated">
                Confirm
            </v-btn>
            </template>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'
import RolesDialog from './Sub-Dialogs/RolesDialog.vue';

export default defineComponent({
    components: {
        RolesDialog
    },
    emits: ["refresh"],
    data(){
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            id: null,
            fname: null,
            mname: null,
            lname: null,
            suffix: null,
            post_nominal: null,
            undergraduate: null,
            graduate: null,
            post_graduate: null,
            employmentStatusId: null,
            academicRankId: null,
            officeId: null,
            programId: null,
            positionId: null,
            core_time: null,
            consultation_time: null,
            designation: null,
            user_sec_id: null,
            status: null,

            email: null,
            password: null,
            confirmPass: null,

            showPass: false,
            showConfirmPass: false,

            employmentStatusData: [],
            academicRankData: [],
            officeData: [],
            programData: [],
            positionData: [],
            rolesData: [],

            confirmDeactivate: false,
            confirmReactivate: false,
            confirmReset: false,
            confirmDeleteRole: false,
            itemToDeactivate: null,
            itemToReactivate: null,
            itemToRemove: null,

            roleData: [],
            roles: null,

            newFormRules: {
                dnscEmail: (value) => /.+@dnsc\.edu\.ph$/.test(value) || 'Must be a DNSC Email',
            },
        }
     },
     methods: {
        initAdd(){
            this.dialog = true
            this.dialog_title = 'Accounts Management'
            this.dialog_sub_title = 'Add new account'
            this.action = 'add'
            this.initForm()
        },
        initView(data){
            this.dialog = true
            this.dialog_title = 'Accounts Management'
            this.dialog_sub_title = 'view account details'
            this.action = 'edit'
            this.initForm()
            
            this.id = data.id
            this.email = data.userSec.email
            this.fname = data.fname
            this.lname = data.lname
            this.mname = data.mname
            this.suffix = data.suffix
            this.post_nominal = data.post_nominal
            this.undergraduate = data.undergraduate
            this.graduate = data.graduate
            this.employmentStatusId = data.employmentStatusId
            this.academicRankId = data.academicRankId
            this.programId = data.programId
            this.officeId = data.officeId
            this.positionId = data.positionId
            this.core_time = data.core_time
            this.consultation_time = data.consultation_time
            this.designation = data.designation
            this.user_sec_id = data.userSec.id
            this.roles = JSON.parse(data.roleId)
            this.status = data.status

            this.loadRoles()

            this.itemToDeactivate = data
            this.itemToReactivate = data
        },
        showAddRoleDialog(){
            this.$refs.RolesDialog.initAdd(this.id)
        },
        showEditRoleDialog(data){
            this.$refs.RolesDialog.initUpdate(data)
        },
        showRemoveRoleDialog(data){
            this.itemToRemove = data.id
            this.confirmDeleteRole = true
        },
        async initForm(){
            const { showSnackbar } = useSnackbar()
            await axios.get(process.env.VUE_APP_SERVER_URL + '/employment-status')
            .then(res => {
                this.employmentStatusData = res.data
            });

            await axios.get(process.env.VUE_APP_SERVER_URL + '/academic-rank')
            .then(res => {
                this.academicRankData = res.data
            });

            await axios.get(process.env.VUE_APP_SERVER_URL + '/offices/getAllOffices')
            .then(res => {
                this.officeData = res.data
            });

            await axios.get(process.env.VUE_APP_SERVER_URL + '/programs')
            .then(res => {
                this.programData = res.data
            });

            await axios.get(process.env.VUE_APP_SERVER_URL + '/position')
            .then(res => {
                this.positionData = res.data
            });

            const token = localStorage.getItem('aums-token')
            axios.get(process.env.VUE_APP_SERVER_URL + '/roles',
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.roleData = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false
                    showSnackbar('Token expired! Logging out..')

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        async loadRoles(){
            await axios.get(process.env.VUE_APP_SERVER_URL + '/user-designation/findAllRolesByUser/' + this.id)
            .then(res => {
                 this.rolesData = res.data
            });
        },
        async deactivateAccount(){
            const { showSnackbar } = useSnackbar()
            const token = localStorage.getItem('aums-token')
            axios.post(process.env.VUE_APP_SERVER_URL + '/user-details/deactivateAccount', this.itemToDeactivate,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data.status == 400){
                    this.loading = false
                    showSnackbar('Error..')
                }
                else{
                    this.$emit('refresh')
                    this.$refs.form.reset()
                    showSnackbar('Account successfully deactivated..')
                    this.loading = false
                    this.dialog = false
                    this.confirmDeactivate = false
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false
                    showSnackbar('Token expired! Logging out..')

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        async reactivateAccount(){
            const { showSnackbar } = useSnackbar()
            const token = localStorage.getItem('aums-token')
            axios.post(process.env.VUE_APP_SERVER_URL + '/user-details/reactivateAccount', this.itemToReactivate,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data.status == 400){
                    this.loading = false
                    showSnackbar('Error..')
                }
                else{
                    this.$emit('refresh')
                    this.$refs.form.reset()
                    showSnackbar('Account successfully reactivated..')
                    this.loading = false
                    this.dialog = false
                    this.confirmReactivate = false
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false
                    showSnackbar('Token expired! Logging out..')

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        async resetPassword(){
            const { showSnackbar } = useSnackbar()
            const token = localStorage.getItem('aums-token')
            axios.patch(process.env.VUE_APP_SERVER_URL + '/user-security/resetPassword/' + this.user_sec_id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data.status == 400){
                    this.loading = false
                    showSnackbar('Error..')
                }
                else{
                    this.$emit('refresh')
                    this.$refs.form.reset()
                    showSnackbar('Account password successfully reset')
                    this.loading = false
                    this.dialog = false
                    this.confirmReset = false
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false
                    showSnackbar('Token expired! Logging out..')

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        async removeRole(){
            const { showSnackbar } = useSnackbar()
            const token = localStorage.getItem('aums-token')
            axios.patch(process.env.VUE_APP_SERVER_URL + '/user-designation/removeRole/' + this.itemToRemove,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data.status == 400){
                    this.loading = false
                    showSnackbar('Error..')
                }
                else{
                    showSnackbar('Role successfully removed')
                    this.loadRoles()
                    this.confirmDeleteRole = false
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false
                    showSnackbar('Token expired! Logging out..')

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        async validateForm(){
            const { showSnackbar } = useSnackbar()
            const { valid } = await this.$refs.form.validate()

            if(valid){
                this.loading = true
                let formData = {
                    userDetails: {
                        id: this.id,
                        fname: this.fname,
                        mname: this.mname,
                        lname: this.lname,
                        suffix: this.suffix,
                        post_nominal: this.post_nominal,
                        undergraduate: this.undergraduate,
                        graduate: this.graduate,
                        post_graduate: this.post_graduate,
                        employmentStatusId: this.employmentStatusId,
                        academicRankId: this.academicRankId,
                        officeId: this.officeId,
                        programId: this.programId,
                        positionId: this.positionId,
                        designation: this.designation,
                        roleId: JSON.stringify(this.roles)
                    },
                    userSec: {
                        email: this.email,
                        password: this.password
                    }
                }

                const token = localStorage.getItem('aums-token')
                
                if(this.action == 'add'){
                    await axios.post(process.env.VUE_APP_SERVER_URL + '/auth/registerUser', formData)
                    .then(res => {
                        if(res.data.status == 409){
                            this.loading = false
                            showSnackbar('This email you entered is already been used')
                        }
                        else if(res.data.status == 400){
                            this.loading = false,
                            showSnackbar('There is an error during registration. Please go to the admin and ask assistance')
                        }
                        else{
                            this.$emit('refresh')
                            this.$refs.form.reset()
                            showSnackbar('Account successfully registered, Please verify and give a role')
                            this.loading = false
                            this.dialog = false
                        }
                    });
                }
                else {
                    await axios.post(process.env.VUE_APP_SERVER_URL + '/user-details/adminUpdateBasicInfo', formData.userDetails,
                    { headers:
                        { 
                            'Authorization': `Bearer ${token}`,
                        }
                    }
                    )
                    .then(res => {
                        if(res.data.status == 200){
                            this.$emit('refresh')
                            this.$refs.form.reset()
                            showSnackbar('Account successfully updated!')
                            this.loading = false
                            this.dialog = false
                        }
                    }); 
                }
            }
        },
        closeDialog(){
            this.$refs.form.reset()
            this.$emit('refresh')
            this.dialog = false
        }
     }
})
</script>

<style scoped>

</style>